var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "upload-modal",
          class: {
            "upload-modal--logged-in": _vm.isLoggedIn,
          },
        },
        [
          _c("transition", { attrs: { name: "bg", appear: "" } }, [
            _vm.$props.opened
              ? _c("div", {
                  staticClass: "upload-modal__bg",
                  on: { click: _vm.onClickClose },
                })
              : _vm._e(),
          ]),
          _c(
            "transition",
            {
              attrs: { name: "reveal", appear: "" },
              on: { enter: _vm.onEnter, leave: _vm.onLeave },
            },
            [
              _vm.$props.opened
                ? _c("div", { staticClass: "upload-modal__box" }, [
                    _c(
                      "div",
                      { staticClass: "upload-modal__box-inner" },
                      [
                        _c(
                          "transition",
                          { attrs: { name: "loader", appear: "" } },
                          [
                            _vm.isLoading
                              ? _c(
                                  "div",
                                  { staticClass: "upload-modal__loader" },
                                  [_c("Loader")],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "upload-modal__contentWrapper" },
                          [
                            _c(
                              "div",
                              { staticClass: "upload-modal__contentScroll" },
                              [
                                !_vm.isLoading
                                  ? _c(
                                      "div",
                                      { staticClass: "upload-modal__content" },
                                      [
                                        _c(
                                          "transition",
                                          {
                                            attrs: {
                                              name: "content",
                                              mode: "out-in",
                                              appear: "",
                                            },
                                          },
                                          [
                                            !_vm.isLoggedIn
                                              ? _c(
                                                  "div",
                                                  { key: "logged-out" },
                                                  [
                                                    _c("p", {
                                                      staticClass:
                                                        "upload-modal__body",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.$t("login_title")
                                                        ),
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "upload-modal__button upload-modal__button--no-max-width",
                                                      },
                                                      [
                                                        _c("ScidButton", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "login_with_supercell"
                                                            ),
                                                          },
                                                          nativeOn: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onClickLogin.apply(
                                                                null,
                                                                arguments
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.isLoggedIn
                                              ? _c(
                                                  "div",
                                                  { key: "logged-in" },
                                                  [
                                                    _c(
                                                      "transition",
                                                      {
                                                        attrs: {
                                                          name: "content",
                                                          mode: "out-in",
                                                          appear: "",
                                                        },
                                                      },
                                                      [
                                                        !_vm.saveCompleted
                                                          ? _c(
                                                              "div",
                                                              { key: "save" },
                                                              [
                                                                _c("p", {
                                                                  staticClass:
                                                                    "upload-modal__body",
                                                                  domProps: {
                                                                    textContent:
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "save_pin_title"
                                                                        )
                                                                      ),
                                                                  },
                                                                }),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "upload-modal__button",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "RectangleButton",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100%",
                                                                          },
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.isUploadCooldown ||
                                                                            _vm.isSaving,
                                                                          slanted:
                                                                            "",
                                                                          color:
                                                                            "blue",
                                                                          label:
                                                                            _vm.$t(
                                                                              _vm.saveButtonLabel
                                                                            ),
                                                                          func: _vm.onClickSave,
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm.isUploadCooldown
                                                                  ? _c("p", {
                                                                      staticClass:
                                                                        "upload-modal__body upload-modal__body--last upload-modal__body--dimmed",
                                                                      domProps:
                                                                        {
                                                                          textContent:
                                                                            _vm._s(
                                                                              _vm.cooldownMessage
                                                                            ),
                                                                        },
                                                                    })
                                                                  : _c("p", {
                                                                      staticClass:
                                                                        "upload-modal__body upload-modal__body--last upload-modal__body--dimmed",
                                                                      domProps:
                                                                        {
                                                                          textContent:
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "save_cooldown_info"
                                                                              )
                                                                            ),
                                                                        },
                                                                    }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm.saveCompleted
                                                          ? _c(
                                                              "div",
                                                              {
                                                                key: "save-result",
                                                              },
                                                              [
                                                                _vm.saveSuccessfull
                                                                  ? _c("div", [
                                                                      _c("p", {
                                                                        staticClass:
                                                                          "upload-modal__body",
                                                                        domProps:
                                                                          {
                                                                            textContent:
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "save_success_new"
                                                                                )
                                                                              ),
                                                                          },
                                                                      }),
                                                                      _c("p", {
                                                                        staticClass:
                                                                          "upload-modal__body upload-modal__body--dimmed",
                                                                        domProps:
                                                                          {
                                                                            textContent:
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "save_disclaimer"
                                                                                )
                                                                              ),
                                                                          },
                                                                      }),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "upload-modal__button",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "RectangleButton",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100%",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  slanted:
                                                                                    "",
                                                                                  color:
                                                                                    "blue",
                                                                                  label:
                                                                                    _vm.$t(
                                                                                      "save_success_cta"
                                                                                    ),
                                                                                  func: _vm.onClickClose,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm.saveFailure
                                                                  ? _c("div", [
                                                                      _c("p", {
                                                                        staticClass:
                                                                          "upload-modal__body",
                                                                        domProps:
                                                                          {
                                                                            textContent:
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "save_error"
                                                                                )
                                                                              ),
                                                                          },
                                                                      }),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "upload-modal__button",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "RectangleButton",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100%",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  slanted:
                                                                                    "",
                                                                                  color:
                                                                                    "blue",
                                                                                  label:
                                                                                    _vm.$t(
                                                                                      "save_error_cta_retry"
                                                                                    ),
                                                                                  func: _vm.onClickRestart,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "upload-modal__button upload-modal__button--last",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "RectangleButton",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100%",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  slanted:
                                                                                    "",
                                                                                  color:
                                                                                    "dark",
                                                                                  label:
                                                                                    _vm.$t(
                                                                                      "save_error_cta_back"
                                                                                    ),
                                                                                  func: _vm.onClickClose,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                        _c("ScidUserBar", {
                          attrs: {
                            opened: !_vm.isLoading && _vm.isLoggedIn,
                            disabled: _vm.isSaving,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "upload-modal__pin" }, [
                      _vm.$props.opened
                        ? _c("img", {
                            ref: "pinImage",
                            staticClass: "upload-modal__pinImage",
                            attrs: { src: _vm.pinBlob },
                          })
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      { staticClass: "upload-modal__close" },
                      [
                        _c("CrossButton", {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.onClickClose.apply(null, arguments)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }